
import React from 'react';
import { Toaster } from "@/components/ui/toaster";
import { DashboardProvider } from '@/contexts/dashboard';
import CompactDashboard from './CompactDashboard';
import CompactLayout from '@/components/layout/CompactLayout';

const DefaultDashboard: React.FC = () => {
  return (
    <DashboardProvider>
      <CompactLayout>
        <div className="p-4 md:p-6 bg-gray-50 dark:bg-gray-900 min-h-[calc(100vh-4rem)]">
          <CompactDashboard />
        </div>
      </CompactLayout>
      <Toaster />
    </DashboardProvider>
  );
};

export default DefaultDashboard;
